export default __webpack_public_path__ + "static/media/issue-from-file.e5d7d0c9.xlsx";